// original starting code 



// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.header = document.querySelector(".header-wrapper");
//     if (this.header) this.header.preventHide = false;

//     this.addEventListener(
//       "keyup",
//       (evt) => evt.code === "Escape" && this.close()
//     );
//     this.querySelector("#CartDrawer-Overlay").addEventListener(
//       "click",
//       this.close.bind(this, false)
//     );
//     this.setHeaderCartIconAccessibility();
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector("#cart-icon-bubble");
//     if (!cartLink) return;
//     cartLink.setAttribute("role", "button");
//     cartLink.setAttribute("aria-haspopup", "dialog");
//     cartLink.addEventListener("click", (event) => {
//       event.preventDefault();
//       if (!this.classList.contains("active")) {
//         this.open(cartLink);
//       } else {
//         this.close();
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (this.header) {
//       this.header.preventHide = true;
//       this.header.preventReveal = true;
//     }
//     if (triggeredBy) this.setActiveElement(triggeredBy);

//     const search = document.querySelector("header-search.header__search");
//     if (search) search.close();

//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
//       this.setSummaryAccessibility(cartDrawerNote);
//     }

//     this.classList.add("active");

//     this.addEventListener(
//       "transitionend",
//       () => {
//         const containerToTrapFocusOn = this.classList.contains("is-empty")
//           ? this.querySelector(".drawer__inner-empty")
//           : document.getElementById("CartDrawer");
//         const focusElement =
//           this.querySelector(".drawer__inner") ||
//           this.querySelector(".drawer__close");
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add("overflow-hidden-drawer");
//   }

//   close() {
//     this.classList.remove("active");

//     if (this.activeElement) {
//       this.activeElement.focus();
//     }

//     document.body.classList.remove("overflow-hidden-drawer");

//     if (this.header) {
//       this.header.preventHide = false;
//       this.header.preventReveal = false;
//     }
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute("role", "button");
//     cartDrawerNote.setAttribute("aria-expanded", "false");

//     if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
//       cartDrawerNote.setAttribute(
//         "aria-controls",
//         cartDrawerNote.nextElementSibling.id
//       );
//     }

//     cartDrawerNote.addEventListener("click", (event) => {
//       event.currentTarget.setAttribute(
//         "aria-expanded",
//         !event.currentTarget.closest("details").hasAttribute("open")
//       );
//     });

//     cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     this.querySelector(".drawer__inner").classList.contains("is-empty") &&
//       this.querySelector(".drawer__inner").classList.remove("is-empty");
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);
//       sectionElement.innerHTML = this.getSectionInnerHTML(
//         parsedState.sections[section.id],
//         section.selector
//       );
//     });

//     setTimeout(() => {
//       this.querySelector("#CartDrawer-Overlay").addEventListener(
//         "click",
//         this.close.bind(this, false)
//       );
//       this.open();
//       if (
//         document.querySelector("cart-popular-products-slider") &&
//         typeof document.querySelector("cart-popular-products-slider").init ===
//           "function"
//       ) {
//         document.querySelector("cart-popular-products-slider").init();
//       }
//     });
//   }

//   getSectionInnerHTML(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: "cart-drawer",
//         selector: "#CartDrawer",
//       },
//       {
//         id: "cart-icon-bubble",
//       },
//     ];
//   }

//   getSectionDOM(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define("cart-drawer", CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: "CartDrawer",
//         section: "cart-drawer",
//         selector: ".drawer__inner",
//       },
//       {
//         id: "cart-icon-bubble",
//         section: "cart-icon-bubble",
//         selector: ".shopify-section",
//       },
//     ];
//   }
// }

// customElements.define("cart-drawer-items", CartDrawerItems);















// Quantity and subscription refresh code (working)







// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.header = document.querySelector(".header-wrapper");
//     if (this.header) this.header.preventHide = false;

//     this.addEventListener(
//       "keyup",
//       (evt) => evt.code === "Escape" && this.close()
//     );
//     this.querySelector("#CartDrawer-Overlay").addEventListener(
//       "click",
//       this.close.bind(this, false)
//     );
//     this.setHeaderCartIconAccessibility();
    
//     // Initialize widget on page load if drawer is already open
//     if (this.classList.contains('active')) {
//       this.initSubscriptionWidget();
//     }
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector("#cart-icon-bubble");
//     if (!cartLink) return;
//     cartLink.setAttribute("role", "button");
//     cartLink.setAttribute("aria-haspopup", "dialog");
//     cartLink.addEventListener("click", (event) => {
//       event.preventDefault();
//       if (!this.classList.contains("active")) {
//         this.open(cartLink);
//       } else {
//         this.close();
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (this.header) {
//       this.header.preventHide = true;
//       this.header.preventReveal = true;
//     }
//     if (triggeredBy) this.setActiveElement(triggeredBy);

//     const search = document.querySelector("header-search.header__search");
//     if (search) search.close();

//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
//       this.setSummaryAccessibility(cartDrawerNote);
//     }

//     this.classList.add("active");

//     // Initialize subscription widget when drawer opens
//     this.initSubscriptionWidget();
    
//     // Trigger event for widget to re-setup
//     document.dispatchEvent(new CustomEvent('cart-drawer-opened'));

//     this.addEventListener(
//       "transitionend",
//       () => {
//         const containerToTrapFocusOn = this.classList.contains("is-empty")
//           ? this.querySelector(".drawer__inner-empty")
//           : document.getElementById("CartDrawer");
//         const focusElement =
//           this.querySelector(".drawer__inner") ||
//           this.querySelector(".drawer__close");
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add("overflow-hidden-drawer");
//   }

//   close() {
//     this.classList.remove("active");

//     if (this.activeElement) {
//       this.activeElement.focus();
//     }

//     document.body.classList.remove("overflow-hidden-drawer");

//     if (this.header) {
//       this.header.preventHide = false;
//       this.header.preventReveal = false;
//     }
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute("role", "button");
//     cartDrawerNote.setAttribute("aria-expanded", "false");

//     if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
//       cartDrawerNote.setAttribute(
//         "aria-controls",
//         cartDrawerNote.nextElementSibling.id
//       );
//     }

//     cartDrawerNote.addEventListener("click", (event) => {
//       event.currentTarget.setAttribute(
//         "aria-expanded",
//         !event.currentTarget.closest("details").hasAttribute("open")
//       );
//     });

//     cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     this.querySelector(".drawer__inner").classList.contains("is-empty") &&
//       this.querySelector(".drawer__inner").classList.remove("is-empty");
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);
//       sectionElement.innerHTML = this.getSectionInnerHTML(
//         parsedState.sections[section.id],
//         section.selector
//       );
//     });

//     setTimeout(() => {
//       this.querySelector("#CartDrawer-Overlay").addEventListener(
//         "click",
//         this.close.bind(this, false)
//       );
//       this.open();
//       if (
//         document.querySelector("cart-popular-products-slider") &&
//         typeof document.querySelector("cart-popular-products-slider").init ===
//           "function"
//       ) {
//         document.querySelector("cart-popular-products-slider").init();
//       }
//     });
//   }

//   getSectionInnerHTML(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: "cart-drawer",
//         selector: "#CartDrawer",
//       },
//       {
//         id: "cart-icon-bubble",
//       },
//     ];
//   }

//   getSectionDOM(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }

//   // ==================================================
//   // INITIALIZE SUBSCRIPTION WIDGET
//   // ==================================================
//   initSubscriptionWidget() {
//     const widget = document.getElementById('subscription-widget');
//     if (!widget) return;
    
//     if (this.classList.contains('is-empty')) {
//       widget.style.display = 'none';
//       return;
//     } else {
//       widget.style.display = 'block';
//     }
    
//     const statusDiv = document.getElementById('widget-status');
//     if (statusDiv) {
//       statusDiv.textContent = '';
//     }
    
//     // Reset the apply button state
//     const applyBtn = document.getElementById('apply-frequency');
//     if (applyBtn) {
//       applyBtn.disabled = false;
//       applyBtn.style.opacity = '1';
//       applyBtn.dataset.updating = 'false';
//     }
//   }

//   // ==================================================
//   // REFRESH CART WITH FULL RE-RENDER
//   // ==================================================
//   async refreshCartDrawer() {
//     try {
//       // Fetch updated cart data
//       const response = await fetch(window.Shopify.routes.root + 'cart.js');
//       const cart = await response.json();
      
//       // Find the cart items container
//       const itemsWrapper = this.querySelector('.drawer__cart-items-wrapper');
//       if (!itemsWrapper) {
//         // Fallback: reload page
//         window.location.reload();
//         return;
//       }
      
//       // Build new HTML for cart items
//       let itemsHTML = '';
//       cart.items.forEach((item, index) => {
//         itemsHTML += this.buildCartItemHTML(item, index + 1);
//       });
      
//       // Replace the content
//       itemsWrapper.innerHTML = itemsHTML;
      
//       // Update subtotal
//       this.updateCartTotal(cart);
      
//       // Update cart count
//       this.updateCartCount(cart);
      
//       // Re-initialize quantity inputs
//       this.reinitQuantityInputs();
      
//       // Re-initialize the subscription widget
//       this.initSubscriptionWidget();
      
//       // Keep the drawer open
//       this.classList.add('active');
      
//       console.log('✅ Cart refreshed with new selling plans');
      
//     } catch (error) {
//       console.error('Error refreshing cart:', error);
//       // Fallback: reload page if refresh fails
//       window.location.reload();
//     }
//   }

//   // ==================================================
//   // BUILD CART ITEM HTML
//   // ==================================================
//   buildCartItemHTML(item, index) {
//     const imageUrl = item.image ? item.image.src : '';
//     const productUrl = item.url || `/products/${item.handle}`;
//     const hasSellingPlan = item.selling_plan_allocation !== null;
//     const sellingPlanName = hasSellingPlan ? item.selling_plan_allocation.selling_plan.name : '';
    
//     // Format prices
//     const price = (item.price / 100).toFixed(2);
//     const originalPrice = (item.original_price / 100).toFixed(2);
    
//     let priceHTML = '';
//     if (item.price < item.original_price) {
//       priceHTML = `
//         <div class="cart-item__discounted-prices">
//           <span class="cart-item__final-price cart-item__final-price_sale">$${price} AUD</span>
//           <s class="cart-item__old-price">$${originalPrice} AUD</s>
//         </div>
//       `;
//     } else {
//       priceHTML = `<div class="cart-item__final-price">$${price} AUD</div>`;
//     }
    
//     // Build option HTML
//     let optionsHTML = '';
//     if (item.options_with_values && item.options_with_values.length > 0) {
//       optionsHTML = '<dl class="product-option__group">';
//       item.options_with_values.forEach(opt => {
//         optionsHTML += `
//           <div class="product-option body-small">
//             <dt>${opt.name}:</dt>
//             <dd>${opt.value}</dd>
//           </div>
//         `;
//       });
//       optionsHTML += '</dl>';
//     }
    
//     // Add selling plan display
//     let sellingPlanHTML = '';
//     if (sellingPlanName) {
//       sellingPlanHTML = `<p class="product-option body-small">${sellingPlanName}</p>`;
//     }
    
//     // Check if line price is different (for quantity > 1)
//     const linePrice = (item.line_price / 100).toFixed(2);
//     const originalLinePrice = (item.original_line_price / 100).toFixed(2);
//     let linePriceHTML = '';
//     if (item.quantity > 1) {
//       if (item.line_price < item.original_line_price) {
//         linePriceHTML = `
//           <div class="cart-item__total-price">
//             <div class="cart-item__price-wrapper">
//               <dl class="cart-item__discounted-prices">
//                 <dt class="visually-hidden">Sale price</dt>
//                 <dd class="cart-item__final-price cart-item__final-price_sale">$${linePrice} AUD</dd>
//                 <dt class="visually-hidden">Regular price</dt>
//                 <dd><s class="cart-item__old-price">$${originalLinePrice} AUD</s></dd>
//               </dl>
//             </div>
//           </div>
//         `;
//       } else {
//         linePriceHTML = `
//           <div class="cart-item__total-price">
//             <div class="cart-item__price-wrapper">
//               <span class="cart-item__final-price">$${linePrice} AUD</span>
//             </div>
//           </div>
//         `;
//       }
//     }
    
//     return `
//       <div id="CartDrawer-Item-${index}" class="cart-item">
//         <div class="cart-item__inner-top">
//           ${imageUrl ? `
//             <div class="cart-item__left">
//               <div class="cart-item__media" style="padding-bottom: 123.58%">
//                 <a href="${productUrl}" class="cart-item__link focus-inset" aria-label="Product link"></a>
//                 <img src="${imageUrl}" alt="${item.title}" class="cart-item__image" style="object-fit: cover;" loading="lazy">
//               </div>
//             </div>
//           ` : ''}
          
//           <div class="cart-item__details">
//             <div class="cart-item__details-wrapper">
//               <div class="cart-item__info">
//                 <div class="cart-item__line">
//                   <div class="cart-item__line-group">
//                     <a href="${productUrl}" class="cart-item__name focus-inset">${item.product_title || item.title}</a>
//                   </div>
//                   <div class="cart-item__price-wrapper">
//                     ${priceHTML}
//                   </div>
//                 </div>
//                 ${optionsHTML}
//                 ${sellingPlanHTML}
//               </div>
//             </div>
            
//             <div id="CartDrawer-LineItemError-${index}" class="cart-item__error" role="alert">
//               <small class="cart-item__error-text"></small>
//               <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
//                 <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
//                 <circle cx="6.5" cy="6.5" r="5.5" fill="#B73C24" stroke="#B73C24" stroke-width="0.7"/>
//                 <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
//                 <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#B73C24" stroke-width="0.7"/>
//               </svg>
//             </div>
            
//             <div class="cart-item__bottom">
//               <div class="cart-item__bottom-controls">
//                 <div class="cart-item__quantity-wrapper">
//                   <label class="visually-hidden" for="Quantity-${index}">Quantity</label>
//                   <quantity-input class="quantity">
//                     <button class="quantity__button no-js-hidden focus-inset" name="minus" type="button">
//                       <span class="visually-hidden">Decrease quantity</span>
//                       <svg class="icon icon-minus" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//                         <path d="M14 10L6 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/>
//                       </svg>
//                     </button>
//                     <input class="quantity__input focus-inset" type="number" name="updates[]" value="${item.quantity}" min="0" aria-label="Quantity" id="Quantity-${index}" data-index="${index}">
//                     <button class="quantity__button no-js-hidden focus-inset" name="plus" type="button">
//                       <span class="visually-hidden">Increase quantity</span>
//                       <svg class="icon icon-plus" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M10 6V14M14 10L6 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/>
//                       </svg>
//                     </button>
//                   </quantity-input>
//                 </div>
//                 <cart-remove-button id="CartDrawer-Remove-${index}" data-index="${index}">
//                   <button type="button" class="button focus-inset" aria-label="Remove item">
//                     <svg class="icon icon-remove" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M11.2714 10.4444V9.74444H9.87143V10.4444H11.2714ZM9.87143 16.6667V17.3667H11.2714V16.6667H9.87143ZM14.1286 10.4444V9.74444H12.7286V10.4444H14.1286ZM12.7286 16.6667V17.3667H14.1286V16.6667H12.7286ZM8.4943 18.8305L8.8339 18.2184H8.8339L8.4943 18.8305ZM7.86999 18.1507L8.50401 17.854L8.50401 17.854L7.86999 18.1507ZM16.13 18.1507L15.496 17.854V17.854L16.13 18.1507ZM15.5057 18.8305L15.1661 18.2184L15.1661 18.2184L15.5057 18.8305ZM7 7.41111H6.3V8.81111H7V7.41111ZM17 8.81111H17.7V7.41111H17V8.81111ZM8.8 8.11111V8.81111H10.2V8.11111H8.8ZM13.8 8.11111V8.81111H15.2V8.11111H13.8ZM9.87143 10.4444V16.6667H11.2714V10.4444H9.87143ZM12.7286 10.4444V16.6667H14.1286V10.4444H12.7286ZM15.5857 8.11111V16.5111H16.9857V8.11111H15.5857ZM14 18.3H10V19.7H14V18.3ZM7.01429 8.11111V16.5111H8.41429V8.11111H7.01429ZM10 18.3C9.5874 18.3 9.32377 18.2994 9.12375 18.2816C8.93384 18.2647 8.86654 18.2365 8.8339 18.2184L8.15469 19.4426C8.42764 19.594 8.71316 19.6506 8.99969 19.6761C9.2761 19.7006 9.61253 19.7 10 19.7V18.3ZM7.01429 16.5111C7.01429 16.9361 7.01383 17.2935 7.03571 17.5852C7.05809 17.8834 7.10679 18.1713 7.23597 18.4473L8.50401 17.854C8.47748 17.7973 8.44833 17.701 8.43179 17.4804C8.41475 17.2533 8.41429 16.9573 8.41429 16.5111H7.01429ZM8.8339 18.2184C8.70086 18.1445 8.5819 18.0204 8.50401 17.854L7.23597 18.4473C7.432 18.8663 7.75013 19.2181 8.1547 19.4426L8.8339 18.2184ZM15.5857 16.5111C15.5857 16.9573 15.5853 17.2533 15.5682 17.4804C15.5517 17.701 15.5225 17.7973 15.496 17.854L16.764 18.4473C16.8932 18.1713 16.9419 17.8834 16.9643 17.5852C16.9862 17.2935 16.9857 16.9361 16.9857 16.5111H15.5857ZM14 19.7C14.3875 19.7 14.7239 19.7006 15.0003 19.6761C15.2868 19.6506 15.5724 19.594 15.8453 19.4426L15.1661 18.2184C15.1335 18.2365 15.0662 18.2647 14.8763 18.2816C14.6762 18.2994 14.4126 18.3 14 18.3V19.7ZM15.496 17.854C15.4181 18.0204 15.2991 18.1445 15.1661 18.2184L15.8453 19.4426C16.2499 19.2181 16.568 18.8663 16.764 18.4473L15.496 17.854ZM7 8.81111H7.71429V7.41111H7V8.81111ZM7.71429 8.81111H16.2857V7.41111H7.71429V8.81111ZM16.2857 8.81111H17V7.41111H16.2857V8.81111ZM10.2 7.48889C10.2 6.50385 11.0029 5.7 12 5.7V4.3C10.2356 4.3 8.8 5.72478 8.8 7.48889H10.2ZM12 5.7C12.9971 5.7 13.8 6.50385 13.8 7.48889H15.2C15.2 5.72478 13.7644 4.3 12 4.3V5.7ZM8.8 7.48889V8.11111H10.2V7.48889H8.8ZM13.8 7.48889V8.11111H15.2V7.48889H13.8Z" fill="currentColor"/>
//                     </svg>
//                   </button>
//                 </cart-remove-button>
//               </div>
//               ${linePriceHTML}
//             </div>
//           </div>
//         </div>
//         <div class="loading-overlay hidden">
//           <div class="loading-overlay__spinner">
//             <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
//               <circle class="path" fill="none" stroke-width="5" cx="33" cy="33" r="30"></circle>
//             </svg>
//           </div>
//         </div>
//       </div>
//     `;
//   }

//   // ==================================================
//   // UPDATE CART TOTAL
//   // ==================================================
//   updateCartTotal(cart) {
//     const subtotalElements = document.querySelectorAll('.totals__subtotal-value span');
//     subtotalElements.forEach(el => {
//       const price = cart.total_price / 100;
//       el.textContent = '$' + price.toFixed(2) + ' AUD';
//     });
//   }

//   // ==================================================
//   // UPDATE CART COUNT
//   // ==================================================
//   updateCartCount(cart) {
//     const countElements = document.querySelectorAll('.cart-count-bubble span');
//     countElements.forEach(el => {
//       el.textContent = cart.item_count;
//     });
//   }

//   // ==================================================
//   // RE-INITIALIZE QUANTITY INPUTS
//   // ==================================================
//   reinitQuantityInputs() {
//     document.querySelectorAll('quantity-input').forEach(el => {
//       // Re-bind any events if needed
//     });
//   }
// }

// customElements.define("cart-drawer", CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: "CartDrawer",
//         section: "cart-drawer",
//         selector: ".drawer__inner",
//       },
//       {
//         id: "cart-icon-bubble",
//         section: "cart-icon-bubble",
//         selector: ".shopify-section",
//       },
//     ];
//   }
// }

// customElements.define("cart-drawer-items", CartDrawerItems);

// // ==================================================
// // FIX: PAGE REFRESH ON QUANTITY CHANGE
// // WITH AUTO-REOPEN DRAWER
// // ==================================================

// // This overrides the CartItems updateQuantity method
// // to trigger a page refresh when quantity changes,
// // with a loading spinner and auto-reopen after refresh.

// (function() {
//     // Store reference to the original method
//     const originalUpdateQuantity = CartItems.prototype.updateQuantity;
    
//     // Override with refresh version
//     CartItems.prototype.updateQuantity = function(line, quantity, name) {
//         // Get current quantity from input
//         const input = document.querySelector(`[data-index="${line}"]`);
//         const currentValue = input ? parseInt(input.value) : 0;
        
//         // If quantity didn't actually change, just call original
//         if (currentValue === quantity) {
//             originalUpdateQuantity.call(this, line, quantity, name);
//             return;
//         }
        
//         // =============================================
//         // SHOW LOADING SPINNER
//         // =============================================
        
//         // Show overlay spinner
//         const overlay = document.getElementById('subscription-loading-overlay');
//         if (overlay) overlay.style.display = 'flex';
        
//         // Disable quantity buttons
//         this.querySelectorAll('.quantity__button').forEach(button => {
//             button.disabled = true;
//             button.classList.add('disabled');
//         });
        
//         // Add loading state to cart items
//         const cartLine = this.querySelector(`#CartDrawer-Item-${line}`) || 
//                         this.querySelector(`#CartItem-${line}`);
//         if (cartLine) {
//             cartLine.classList.add('loading');
//             const loadingElement = cartLine.querySelector('.loading-overlay');
//             if (loadingElement) loadingElement.classList.remove('hidden');
//         }
        
//         // =============================================
//         // UPDATE CART & REFRESH
//         // =============================================
        
//         // Enable loading state
//         this.enableLoading(line);
        
//         // Prepare the request body
//         const body = JSON.stringify({
//             line: parseInt(line),
//             quantity: parseInt(quantity),
//             sections: this.getSectionsToRender().map((section) => section.section),
//             sections_url: window.location.pathname,
//         });

//         // Send the update request
//         fetch(`${routes.cart_change_url}`, { 
//             ...fetchConfig(), 
//             ...{ body } 
//         })
//         .then((response) => response.text())
//         .then((state) => {
//             // Set flag to reopen drawer after refresh
//             sessionStorage.setItem('reopenCartDrawer', 'true');
            
//             // Small delay to let the cart update complete, then refresh
//             setTimeout(() => {
//                 window.location.reload();
//             }, 400);
//         })
//         .catch((error) => {
//             console.error('Cart update failed:', error);
//             // Hide loading on error
//             if (overlay) overlay.style.display = 'none';
//             this.querySelectorAll('.quantity__button').forEach(button => {
//                 button.disabled = false;
//                 button.classList.remove('disabled');
//             });
//             const errors = document.getElementById("cart-errors") || 
//                           document.getElementById("CartDrawer-CartErrors");
//             if (errors) errors.textContent = window.cartStrings.error;
//         });
//     };
// })();

// // ==================================================
// // AUTO-REOPEN DRAWER ON SUBSCRIPTION UPDATES
// // ==================================================

// document.addEventListener('subscription:updated', function() {
//     sessionStorage.setItem('reopenCartDrawer', 'true');
//     setTimeout(() => {
//         window.location.reload();
//     }, 300);
// });

// console.log('✅ Cart drawer with page refresh on quantity change loaded');


















// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.header = document.querySelector(".header-wrapper");
//     if (this.header) this.header.preventHide = false;

//     this.addEventListener(
//       "keyup",
//       (evt) => evt.code === "Escape" && this.close()
//     );
//     this.querySelector("#CartDrawer-Overlay").addEventListener(
//       "click",
//       this.close.bind(this, false)
//     );
//     this.setHeaderCartIconAccessibility();

//     if (this.classList.contains('active')) {
//       this.initSubscriptionWidget();
//     }
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector("#cart-icon-bubble");
//     if (!cartLink) return;
//     cartLink.setAttribute("role", "button");
//     cartLink.setAttribute("aria-haspopup", "dialog");
//     cartLink.addEventListener("click", (event) => {
//       event.preventDefault();
//       if (!this.classList.contains("active")) {
//         this.open(cartLink);
//       } else {
//         this.close();
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (this.header) {
//       this.header.preventHide = true;
//       this.header.preventReveal = true;
//     }
//     if (triggeredBy) this.setActiveElement(triggeredBy);

//     const search = document.querySelector("header-search.header__search");
//     if (search) search.close();

//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
//       this.setSummaryAccessibility(cartDrawerNote);
//     }

//     this.classList.add("active");

//     this.initSubscriptionWidget();
//     this.overrideQuantityUpdates();
//     this.overrideRemoveButtons();

//     this.addEventListener(
//       "transitionend",
//       () => {
//         const containerToTrapFocusOn = this.classList.contains("is-empty")
//           ? this.querySelector(".drawer__inner-empty")
//           : document.getElementById("CartDrawer");
//         const focusElement =
//           this.querySelector(".drawer__inner") ||
//           this.querySelector(".drawer__close");
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add("overflow-hidden-drawer");
//   }

//   close() {
//     this.classList.remove("active");

//     if (this.activeElement) {
//       this.activeElement.focus();
//     }

//     document.body.classList.remove("overflow-hidden-drawer");

//     if (this.header) {
//       this.header.preventHide = false;
//       this.header.preventReveal = false;
//     }
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute("role", "button");
//     cartDrawerNote.setAttribute("aria-expanded", "false");

//     if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
//       cartDrawerNote.setAttribute(
//         "aria-controls",
//         cartDrawerNote.nextElementSibling.id
//       );
//     }

//     cartDrawerNote.addEventListener("click", (event) => {
//       event.currentTarget.setAttribute(
//         "aria-expanded",
//         !event.currentTarget.closest("details").hasAttribute("open")
//       );
//     });

//     cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
//   }

//   overrideRemoveButtons() {
//     const removeButtons = this.querySelectorAll('cart-remove-button');
    
//     removeButtons.forEach(buttonWrapper => {
//       const button = buttonWrapper.querySelector('button');
//       if (!button) return;
      
//       const lineIndex = buttonWrapper.dataset.index;
//       if (!lineIndex) return;
      
//       const newButtonWrapper = buttonWrapper.cloneNode(true);
//       buttonWrapper.parentNode.replaceChild(newButtonWrapper, buttonWrapper);
      
//       const newButton = newButtonWrapper.querySelector('button');
//       if (!newButton) return;
      
//       newButton.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         this.removeItem(lineIndex);
//       });
//     });
//   }

//   async removeItem(lineIndex) {
//     const itemEl = document.getElementById('CartDrawer-Item-' + lineIndex);
//     const itemOverlay = itemEl ? itemEl.querySelector('.loading-overlay') : null;
//     const subtotalOverlay = document.querySelector('.totals__subtotal-value .loading-overlay');

//     if (itemOverlay) itemOverlay.classList.remove('hidden');
//     if (subtotalOverlay) subtotalOverlay.classList.remove('hidden');

//     try {
//       const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({
//           line: parseInt(lineIndex),
//           quantity: 0,
//           sections: ['cart-drawer', 'cart-icon-bubble'],
//           sections_url: window.location.pathname
//         })
//       });
      
//       if (!response.ok) {
//         throw new Error(`Failed to remove item: ${response.status}`);
//       }
      
//       const cartData = await response.json();
      
//       if (cartData.item_count === 0) {
//         const drawer = document.querySelector('cart-drawer');
//         if (drawer) {
//           drawer.renderContents(cartData);
//         }
//         return;
//       }
      
//       const subscribeRadio = document.getElementById('purchase-subscribe');
//       const freqSelect = document.getElementById('frequency-select');
//       const selectedPlan = (subscribeRadio && subscribeRadio.checked) ? freqSelect?.value : null;
      
//       if (selectedPlan) {
//         await this.reapplyPlanToRemainingItems(parseInt(selectedPlan));
//       }
      
//       const drawer = document.querySelector('cart-drawer');
//       if (drawer) {
//         const freshCart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
//         if (freshCart.sections && freshCart.sections['cart-drawer']) {
//           drawer.renderContents(freshCart);
//         } else {
//           drawer.open();
//         }
//       }
      
//       setTimeout(() => {
//         if (typeof window.updateWidgetState === 'function') {
//           window.updateWidgetState();
//         }
//         if (typeof window.updateMinimumOrderWarning === 'function') {
//           window.updateMinimumOrderWarning();
//         }
//       }, 100);
      
//     } catch (error) {
//       console.error('Error removing item:', error);
//       const statusDiv = document.getElementById('widget-status');
//       if (statusDiv) {
//         statusDiv.textContent = 'Failed to remove item. Please try again.';
//         statusDiv.style.color = '#b73c24';
//       }
//     } finally {
//       if (itemOverlay) itemOverlay.classList.add('hidden');
//       if (subtotalOverlay) subtotalOverlay.classList.add('hidden');
//     }
//   }

//   async reapplyPlanToRemainingItems(planId) {
//     try {
//       const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
//       if (!cart.items || cart.items.length === 0) return;
      
//       const sellingPlanId = parseInt(planId);
      
//       const eligibilityPromises = cart.items.map(async (item, index) => {
//         try {
//           const productData = await fetch(`/products/${item.handle}.js`).then(r => r.json());
//           const supportsPlan = (productData.selling_plan_groups || []).some(group =>
//             group.selling_plans.some(plan => plan.id === sellingPlanId)
//           );
//           return { index, supportsPlan };
//         } catch (e) {
//           return { index, supportsPlan: false };
//         }
//       });
      
//       const eligibilityResults = await Promise.all(eligibilityPromises);
      
//       for (let i = 0; i < cart.items.length; i++) {
//         const item = cart.items[i];
//         const planToApply = eligibilityResults[i].supportsPlan ? sellingPlanId : null;
        
//         await fetch(window.Shopify.routes.root + 'cart/change.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'X-Requested-With': 'XMLHttpRequest'
//           },
//           body: JSON.stringify({
//             line: i + 1,
//             quantity: item.quantity,
//             selling_plan: planToApply
//           })
//         });
//       }
      
//     } catch (error) {
//       console.error('Error reapplying plan after removal:', error);
//     }
//   }

//   overrideQuantityUpdates() {
//     const quantityWrappers = this.querySelectorAll('.quantity');
    
//     quantityWrappers.forEach(wrapper => {
//       const input = wrapper.querySelector('.quantity__input');
//       const minusBtn = wrapper.querySelector('button[name="minus"]');
//       const plusBtn = wrapper.querySelector('button[name="plus"]');
      
//       if (!input) return;
      
//       const lineIndex = input.dataset.index;
//       if (!lineIndex) return;
      
//       if (minusBtn) {
//         const newMinus = minusBtn.cloneNode(true);
//         minusBtn.parentNode.replaceChild(newMinus, minusBtn);
//         newMinus.addEventListener('click', (e) => {
//           e.preventDefault();
//           e.stopPropagation();
//           const currentValue = parseInt(input.value) || 0;
//           if (currentValue > 0) {
//             this.updateQuantity(lineIndex, currentValue - 1);
//           }
//         });
//       }
      
//       if (plusBtn) {
//         const newPlus = plusBtn.cloneNode(true);
//         plusBtn.parentNode.replaceChild(newPlus, plusBtn);
//         newPlus.addEventListener('click', (e) => {
//           e.preventDefault();
//           e.stopPropagation();
//           const currentValue = parseInt(input.value) || 0;
//           this.updateQuantity(lineIndex, currentValue + 1);
//         });
//       }
      
//       const newInput = input.cloneNode(true);
//       input.parentNode.replaceChild(newInput, input);
//       newInput.addEventListener('change', (e) => {
//         const newValue = parseInt(e.target.value) || 0;
//         if (newValue >= 0) {
//           this.updateQuantity(lineIndex, newValue);
//         }
//       });
//     });
//   }

//   async updateQuantity(lineIndex, quantity) {
//     const itemEl = document.getElementById('CartDrawer-Item-' + lineIndex);
//     const itemOverlay = itemEl ? itemEl.querySelector('.loading-overlay') : null;
//     const subtotalOverlay = document.querySelector('.totals__subtotal-value .loading-overlay');

//     if (itemOverlay) itemOverlay.classList.remove('hidden');
//     if (subtotalOverlay) subtotalOverlay.classList.remove('hidden');
    
//     try {
//       const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
//       const item = cart.items[parseInt(lineIndex) - 1];
//       if (!item) {
//         const drawer = document.querySelector('cart-drawer');
//         if (drawer) drawer.open();
//         return;
//       }
      
//       const subscribeRadio = document.getElementById('purchase-subscribe');
//       const freqSelect = document.getElementById('frequency-select');
//       const selectedPlan = (subscribeRadio && subscribeRadio.checked) ? freqSelect?.value : null;
      
//       let planToApply = selectedPlan ? parseInt(selectedPlan) : null;
      
//       if (planToApply) {
//         try {
//           const productData = await fetch(`/products/${item.handle}.js`).then(r => r.json());
//           const supportsPlan = (productData.selling_plan_groups || []).some(group =>
//             group.selling_plans.some(plan => plan.id === planToApply)
//           );
//           if (!supportsPlan) {
//             planToApply = null;
//           }
//         } catch (e) {
//           planToApply = null;
//         }
//       }
      
//       const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({
//           line: parseInt(lineIndex),
//           quantity: quantity,
//           selling_plan: planToApply,
//           sections: ['cart-drawer', 'cart-icon-bubble'],
//           sections_url: window.location.pathname
//         })
//       });
      
//       if (!response.ok) {
//         throw new Error(`Failed to update quantity: ${response.status}`);
//       }
      
//       const cartData = await response.json();
      
//       this.renderContents(cartData);
      
//       setTimeout(() => {
//         if (typeof window.updateWidgetState === 'function') {
//           window.updateWidgetState();
//         }
//         if (typeof window.updateMinimumOrderWarning === 'function') {
//           window.updateMinimumOrderWarning();
//         }
//       }, 100);
      
//     } catch (error) {
//       console.error('Error updating quantity:', error);
//       const statusDiv = document.getElementById('widget-status');
//       if (statusDiv) {
//         statusDiv.textContent = 'Failed to update quantity. Please try again.';
//         statusDiv.style.color = '#b73c24';
//       }
//     } finally {
//       if (itemOverlay) itemOverlay.classList.add('hidden');
//       if (subtotalOverlay) subtotalOverlay.classList.add('hidden');
//     }
//   }

//   renderContents(parsedState) {
//     try {
//       if (!parsedState || !parsedState.sections) {
//         this.open();
//         return;
//       }

//       if (parsedState.item_count === 0) {
//         this.querySelector(".drawer__inner")?.classList.add("is-empty");
//       } else {
//         this.querySelector(".drawer__inner")?.classList.remove("is-empty");
//       }

//       this.productId = parsedState.id;
//       this.getSectionsToRender().forEach((section) => {
//         const sectionElement = section.selector
//           ? document.querySelector(section.selector)
//           : document.getElementById(section.id);
        
//         if (sectionElement && parsedState.sections && parsedState.sections[section.id]) {
//           sectionElement.innerHTML = this.getSectionInnerHTML(
//             parsedState.sections[section.id],
//             section.selector
//           );
//         }
//       });

//       setTimeout(() => {
//         this.querySelector("#CartDrawer-Overlay")?.addEventListener(
//           "click",
//           this.close.bind(this, false)
//         );
//         this.open();
//         if (
//           document.querySelector("cart-popular-products-slider") &&
//           typeof document.querySelector("cart-popular-products-slider").init ===
//             "function"
//         ) {
//           document.querySelector("cart-popular-products-slider").init();
//         }
        
//         this.initSubscriptionWidget();
//         this.overrideQuantityUpdates();
//         this.overrideRemoveButtons();
        
//         setTimeout(() => {
//           if (typeof window.updateMinimumOrderWarning === 'function') {
//             window.updateMinimumOrderWarning();
//           }
//         }, 200);
//       }, 100);
//     } catch (error) {
//       console.error('Error in renderContents:', error);
//       this.open();
//     }
//   }

//   getSectionInnerHTML(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: "cart-drawer",
//         selector: "#CartDrawer",
//       },
//       {
//         id: "cart-icon-bubble",
//       },
//     ];
//   }

//   getSectionDOM(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }

//   initSubscriptionWidget() {
//     const widget = document.getElementById('subscription-widget');
//     if (!widget) return;

//     if (this.classList.contains('is-empty')) {
//       widget.style.display = 'none';
//       return;
//     } else {
//       widget.style.display = 'block';
//     }

//     const statusDiv = document.getElementById('widget-status');
//     if (statusDiv) {
//       statusDiv.textContent = '';
//     }
    
//     const onetimeRadio = document.getElementById('purchase-onetime');
//     if (onetimeRadio && onetimeRadio.dataset.wired !== 'true') {
//       if (typeof setupWidget === 'function') {
//         setupWidget();
//       }
//     }
    
//     if (typeof window.updateWidgetState === 'function') {
//       setTimeout(() => {
//         window.updateWidgetState();
//       }, 100);
//     }
//   }
// }

// customElements.define("cart-drawer", CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: "CartDrawer",
//         section: "cart-drawer",
//         selector: ".drawer__inner",
//       },
//       {
//         id: "cart-icon-bubble",
//         section: "cart-icon-bubble",
//         selector: ".shopify-section",
//       },
//     ];
//   }
// }

// customElements.define("cart-drawer-items", CartDrawerItems);







// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.header = document.querySelector(".header-wrapper");
//     if (this.header) this.header.preventHide = false;

//     this.addEventListener(
//       "keyup",
//       (evt) => evt.code === "Escape" && this.close()
//     );
//     this.querySelector("#CartDrawer-Overlay").addEventListener(
//       "click",
//       this.close.bind(this, false)
//     );
//     this.setHeaderCartIconAccessibility();

//     if (this.classList.contains('active')) {
//       this.initSubscriptionWidget();
//     }
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector("#cart-icon-bubble");
//     if (!cartLink) return;
//     cartLink.setAttribute("role", "button");
//     cartLink.setAttribute("aria-haspopup", "dialog");
//     cartLink.addEventListener("click", (event) => {
//       event.preventDefault();
//       if (!this.classList.contains("active")) {
//         this.open(cartLink);
//       } else {
//         this.close();
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (this.header) {
//       this.header.preventHide = true;
//       this.header.preventReveal = true;
//     }
//     if (triggeredBy) this.setActiveElement(triggeredBy);

//     const search = document.querySelector("header-search.header__search");
//     if (search) search.close();

//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
//       this.setSummaryAccessibility(cartDrawerNote);
//     }

//     this.classList.add("active");

//     this.initSubscriptionWidget();
//     this.overrideQuantityUpdates();
//     this.overrideRemoveButtons();

//     this.addEventListener(
//       "transitionend",
//       () => {
//         const containerToTrapFocusOn = this.classList.contains("is-empty")
//           ? this.querySelector(".drawer__inner-empty")
//           : document.getElementById("CartDrawer");
//         const focusElement =
//           this.querySelector(".drawer__inner") ||
//           this.querySelector(".drawer__close");
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add("overflow-hidden-drawer");
//   }

//   close() {
//     this.classList.remove("active");

//     if (this.activeElement) {
//       this.activeElement.focus();
//     }

//     document.body.classList.remove("overflow-hidden-drawer");

//     if (this.header) {
//       this.header.preventHide = false;
//       this.header.preventReveal = false;
//     }
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute("role", "button");
//     cartDrawerNote.setAttribute("aria-expanded", "false");

//     if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
//       cartDrawerNote.setAttribute(
//         "aria-controls",
//         cartDrawerNote.nextElementSibling.id
//       );
//     }

//     cartDrawerNote.addEventListener("click", (event) => {
//       event.currentTarget.setAttribute(
//         "aria-expanded",
//         !event.currentTarget.closest("details").hasAttribute("open")
//       );
//     });

//     cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
//   }

//   overrideRemoveButtons() {
//     const removeButtons = this.querySelectorAll('cart-remove-button');
    
//     removeButtons.forEach(buttonWrapper => {
//       const button = buttonWrapper.querySelector('button');
//       if (!button) return;
      
//       const lineIndex = buttonWrapper.dataset.index;
//       if (!lineIndex) return;
      
//       const newButtonWrapper = buttonWrapper.cloneNode(true);
//       buttonWrapper.parentNode.replaceChild(newButtonWrapper, buttonWrapper);
      
//       const newButton = newButtonWrapper.querySelector('button');
//       if (!newButton) return;
      
//       newButton.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         this.removeItem(lineIndex);
//       });
//     });
//   }

//   // ============================================================
//   // FIXED: removeItem
//   // Removes the line, re-applies the subscription plan to the
//   // remaining items, and only THEN re-renders the drawer from the
//   // final cart state (via refreshDrawer).
//   // ============================================================
//   async removeItem(lineIndex) {
//     const itemEl = document.getElementById('CartDrawer-Item-' + lineIndex);
//     const itemOverlay = itemEl ? itemEl.querySelector('.loading-overlay') : null;
//     const subtotalOverlay = document.querySelector('.totals__subtotal-value .loading-overlay');

//     if (itemOverlay) itemOverlay.classList.remove('hidden');
//     if (subtotalOverlay) subtotalOverlay.classList.remove('hidden');

//     try {
//       const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({
//           line: parseInt(lineIndex),
//           quantity: 0
//         })
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to remove item: ${response.status}`);
//       }

//       const cartData = await response.json();

//       if (cartData.item_count > 0) {
//         const subscribeRadio = document.getElementById('purchase-subscribe');
//         const freqSelect = document.getElementById('frequency-select');
//         const selectedPlan = (subscribeRadio && subscribeRadio.checked) ? freqSelect?.value : null;

//         if (selectedPlan) {
//           await this.reapplyPlanToRemainingItems(parseInt(selectedPlan));
//         }
//       }

//       // Always re-render from the final cart state
//       await this.refreshDrawer();

//       setTimeout(() => {
//         if (typeof window.updateWidgetState === 'function') {
//           window.updateWidgetState();
//         }
//         if (typeof window.updateMinimumOrderWarning === 'function') {
//           window.updateMinimumOrderWarning();
//         }
//       }, 100);

//     } catch (error) {
//       console.error('Error removing item:', error);
//       const statusDiv = document.getElementById('widget-status');
//       if (statusDiv) {
//         statusDiv.textContent = 'Failed to remove item. Please try again.';
//         statusDiv.style.color = '#b73c24';
//         statusDiv.style.display = 'block';
//       }
//     } finally {
//       if (itemOverlay) itemOverlay.classList.add('hidden');
//       if (subtotalOverlay) subtotalOverlay.classList.add('hidden');
//     }
//   }

//   // ============================================================
//   // NEW: refreshDrawer
//   // /cart.js does not return rendered sections, so we fetch them
//   // with the Section Rendering API and pass them to renderContents.
//   // ============================================================
//   async refreshDrawer() {
//     const [sections, cart] = await Promise.all([
//       fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`).then(r => r.json()),
//       fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json())
//     ]);
//     this.renderContents({ ...cart, sections });
//   }

//   async reapplyPlanToRemainingItems(planId) {
//     try {
//       const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
//       if (!cart.items || cart.items.length === 0) return;
      
//       const sellingPlanId = parseInt(planId);
      
//       const eligibilityPromises = cart.items.map(async (item, index) => {
//         try {
//           const productData = await fetch(`/products/${item.handle}.js`).then(r => r.json());
//           const supportsPlan = (productData.selling_plan_groups || []).some(group =>
//             group.selling_plans.some(plan => plan.id === sellingPlanId)
//           );
//           return { index, supportsPlan };
//         } catch (e) {
//           return { index, supportsPlan: false };
//         }
//       });
      
//       const eligibilityResults = await Promise.all(eligibilityPromises);
      
//       for (let i = 0; i < cart.items.length; i++) {
//         const item = cart.items[i];
//         const planToApply = eligibilityResults[i].supportsPlan ? sellingPlanId : null;
        
//         await fetch(window.Shopify.routes.root + 'cart/change.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'X-Requested-With': 'XMLHttpRequest'
//           },
//           body: JSON.stringify({
//             line: i + 1,
//             quantity: item.quantity,
//             selling_plan: planToApply
//           })
//         });
//       }
      
//     } catch (error) {
//       console.error('Error reapplying plan after removal:', error);
//     }
//   }

//   overrideQuantityUpdates() {
//     const quantityWrappers = this.querySelectorAll('.quantity');
    
//     quantityWrappers.forEach(wrapper => {
//       const input = wrapper.querySelector('.quantity__input');
//       const minusBtn = wrapper.querySelector('button[name="minus"]');
//       const plusBtn = wrapper.querySelector('button[name="plus"]');
      
//       if (!input) return;
      
//       const lineIndex = input.dataset.index;
//       if (!lineIndex) return;
      
//       if (minusBtn) {
//         const newMinus = minusBtn.cloneNode(true);
//         minusBtn.parentNode.replaceChild(newMinus, minusBtn);
//         newMinus.addEventListener('click', (e) => {
//           e.preventDefault();
//           e.stopPropagation();
//           const currentValue = parseInt(input.value) || 0;
//           if (currentValue > 0) {
//             this.updateQuantity(lineIndex, currentValue - 1);
//           }
//         });
//       }
      
//       if (plusBtn) {
//         const newPlus = plusBtn.cloneNode(true);
//         plusBtn.parentNode.replaceChild(newPlus, plusBtn);
//         newPlus.addEventListener('click', (e) => {
//           e.preventDefault();
//           e.stopPropagation();
//           const currentValue = parseInt(input.value) || 0;
//           this.updateQuantity(lineIndex, currentValue + 1);
//         });
//       }
      
//       const newInput = input.cloneNode(true);
//       input.parentNode.replaceChild(newInput, input);
//       newInput.addEventListener('change', (e) => {
//         const newValue = parseInt(e.target.value) || 0;
//         if (newValue >= 0) {
//           this.updateQuantity(lineIndex, newValue);
//         }
//       });
//     });
//   }

//   async updateQuantity(lineIndex, quantity) {
//     const itemEl = document.getElementById('CartDrawer-Item-' + lineIndex);
//     const itemOverlay = itemEl ? itemEl.querySelector('.loading-overlay') : null;
//     const subtotalOverlay = document.querySelector('.totals__subtotal-value .loading-overlay');

//     if (itemOverlay) itemOverlay.classList.remove('hidden');
//     if (subtotalOverlay) subtotalOverlay.classList.remove('hidden');
    
//     try {
//       const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
//       const item = cart.items[parseInt(lineIndex) - 1];
//       if (!item) {
//         const drawer = document.querySelector('cart-drawer');
//         if (drawer) drawer.open();
//         return;
//       }
      
//       const subscribeRadio = document.getElementById('purchase-subscribe');
//       const freqSelect = document.getElementById('frequency-select');
//       const selectedPlan = (subscribeRadio && subscribeRadio.checked) ? freqSelect?.value : null;
      
//       let planToApply = selectedPlan ? parseInt(selectedPlan) : null;
      
//       if (planToApply) {
//         try {
//           const productData = await fetch(`/products/${item.handle}.js`).then(r => r.json());
//           const supportsPlan = (productData.selling_plan_groups || []).some(group =>
//             group.selling_plans.some(plan => plan.id === planToApply)
//           );
//           if (!supportsPlan) {
//             planToApply = null;
//           }
//         } catch (e) {
//           planToApply = null;
//         }
//       }
      
//       const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({
//           line: parseInt(lineIndex),
//           quantity: quantity,
//           selling_plan: planToApply,
//           sections: ['cart-drawer', 'cart-icon-bubble'],
//           sections_url: window.location.pathname
//         })
//       });
      
//       if (!response.ok) {
//         throw new Error(`Failed to update quantity: ${response.status}`);
//       }
      
//       const cartData = await response.json();
      
//       this.renderContents(cartData);
      
//       setTimeout(() => {
//         if (typeof window.updateWidgetState === 'function') {
//           window.updateWidgetState();
//         }
//         if (typeof window.updateMinimumOrderWarning === 'function') {
//           window.updateMinimumOrderWarning();
//         }
//       }, 100);
      
//     } catch (error) {
//       console.error('Error updating quantity:', error);
//       const statusDiv = document.getElementById('widget-status');
//       if (statusDiv) {
//         statusDiv.textContent = 'Failed to update quantity. Please try again.';
//         statusDiv.style.color = '#b73c24';
//       }
//     } finally {
//       if (itemOverlay) itemOverlay.classList.add('hidden');
//       if (subtotalOverlay) subtotalOverlay.classList.add('hidden');
//     }
//   }

//   renderContents(parsedState) {
//     try {
//       if (!parsedState || !parsedState.sections) {
//         this.open();
//         return;
//       }

//       if (parsedState.item_count === 0) {
//         this.querySelector(".drawer__inner")?.classList.add("is-empty");
//       } else {
//         this.querySelector(".drawer__inner")?.classList.remove("is-empty");
//       }

//       this.productId = parsedState.id;
//       this.getSectionsToRender().forEach((section) => {
//         const sectionElement = section.selector
//           ? document.querySelector(section.selector)
//           : document.getElementById(section.id);
        
//         if (sectionElement && parsedState.sections && parsedState.sections[section.id]) {
//           sectionElement.innerHTML = this.getSectionInnerHTML(
//             parsedState.sections[section.id],
//             section.selector
//           );
//         }
//       });

//       setTimeout(() => {
//         this.querySelector("#CartDrawer-Overlay")?.addEventListener(
//           "click",
//           this.close.bind(this, false)
//         );
//         this.open();
//         if (
//           document.querySelector("cart-popular-products-slider") &&
//           typeof document.querySelector("cart-popular-products-slider").init ===
//             "function"
//         ) {
//           document.querySelector("cart-popular-products-slider").init();
//         }
        
//         this.initSubscriptionWidget();
//         this.overrideQuantityUpdates();
//         this.overrideRemoveButtons();
        
//         setTimeout(() => {
//           if (typeof window.updateMinimumOrderWarning === 'function') {
//             window.updateMinimumOrderWarning();
//           }
//         }, 200);
//       }, 100);
//     } catch (error) {
//       console.error('Error in renderContents:', error);
//       this.open();
//     }
//   }

//   getSectionInnerHTML(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: "cart-drawer",
//         selector: "#CartDrawer",
//       },
//       {
//         id: "cart-icon-bubble",
//       },
//     ];
//   }

//   getSectionDOM(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }

//   initSubscriptionWidget() {
//     const widget = document.getElementById('subscription-widget');
//     if (!widget) return;

//     if (this.classList.contains('is-empty')) {
//       widget.style.display = 'none';
//       return;
//     } else {
//       widget.style.display = 'block';
//     }

//     const statusDiv = document.getElementById('widget-status');
//     if (statusDiv) {
//       statusDiv.textContent = '';
//     }
    
//     const onetimeRadio = document.getElementById('purchase-onetime');
//     if (onetimeRadio && onetimeRadio.dataset.wired !== 'true') {
//       if (typeof setupWidget === 'function') {
//         setupWidget();
//       }
//     }
    
//     if (typeof window.updateWidgetState === 'function') {
//       setTimeout(() => {
//         window.updateWidgetState();
//       }, 100);
//     }
//   }
// }

// customElements.define("cart-drawer", CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: "CartDrawer",
//         section: "cart-drawer",
//         selector: ".drawer__inner",
//       },
//       {
//         id: "cart-icon-bubble",
//         section: "cart-icon-bubble",
//         selector: ".shopify-section",
//       },
//     ];
//   }
// }

// customElements.define("cart-drawer-items", CartDrawerItems);





class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector(".header-wrapper");
    if (this.header) this.header.preventHide = false;

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this, false)
    );
    this.setHeaderCartIconAccessibility();

    if (this.classList.contains('active')) {
      this.initSubscriptionWidget();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      if (!this.classList.contains("active")) {
        this.open(cartLink);
      } else {
        this.close();
      }
    });
  }

  open(triggeredBy) {
    if (this.header) {
      this.header.preventHide = true;
      this.header.preventReveal = true;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const search = document.querySelector("header-search.header__search");
    if (search) search.close();

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    this.classList.add("active");

    this.initSubscriptionWidget();
    this.overrideQuantityUpdates();
    this.overrideRemoveButtons();

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden-drawer");
  }

  close() {
    this.classList.remove("active");

    if (this.activeElement) {
      this.activeElement.focus();
    }

    document.body.classList.remove("overflow-hidden-drawer");

    if (this.header) {
      this.header.preventHide = false;
      this.header.preventReveal = false;
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  overrideRemoveButtons() {
    const removeButtons = this.querySelectorAll('cart-remove-button');
    
    removeButtons.forEach(buttonWrapper => {
      const button = buttonWrapper.querySelector('button');
      if (!button) return;
      
      const lineIndex = buttonWrapper.dataset.index;
      if (!lineIndex) return;
      
      const newButtonWrapper = buttonWrapper.cloneNode(true);
      buttonWrapper.parentNode.replaceChild(newButtonWrapper, buttonWrapper);
      
      const newButton = newButtonWrapper.querySelector('button');
      if (!newButton) return;
      
      newButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.removeItem(lineIndex);
      });
    });
  }

  // ============================================================
  // removeItem
  // Removes the line, re-applies the subscription plan to the
  // remaining items, and only THEN patches the drawer from the
  // final cart state (via refreshDrawer).
  // ============================================================
  async removeItem(lineIndex) {
    const itemEl = document.getElementById('CartDrawer-Item-' + lineIndex);
    const itemOverlay = itemEl ? itemEl.querySelector('.loading-overlay') : null;
    const subtotalOverlay = document.querySelector('.totals__subtotal-value .loading-overlay');

    if (itemOverlay) itemOverlay.classList.remove('hidden');
    if (subtotalOverlay) subtotalOverlay.classList.remove('hidden');

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          line: parseInt(lineIndex),
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error(`Failed to remove item: ${response.status}`);
      }

      const cartData = await response.json();

      if (cartData.item_count > 0) {
        const subscribeRadio = document.getElementById('purchase-subscribe');
        const freqSelect = document.getElementById('frequency-select');
        const selectedPlan = (subscribeRadio && subscribeRadio.checked) ? freqSelect?.value : null;

        if (selectedPlan) {
          await this.reapplyPlanToRemainingItems(parseInt(selectedPlan));
        }
      }

      // Always update from the final cart state
      await this.refreshDrawer();

      setTimeout(() => {
        if (typeof window.updateWidgetState === 'function') {
          window.updateWidgetState();
        }
        if (typeof window.updateMinimumOrderWarning === 'function') {
          window.updateMinimumOrderWarning();
        }
      }, 100);

    } catch (error) {
      console.error('Error removing item:', error);
      const statusDiv = document.getElementById('widget-status');
      if (statusDiv) {
        statusDiv.textContent = 'Failed to remove item. Please try again.';
        statusDiv.style.color = '#b73c24';
        statusDiv.style.display = 'block';
      }
    } finally {
      if (itemOverlay) itemOverlay.classList.add('hidden');
      if (subtotalOverlay) subtotalOverlay.classList.add('hidden');
    }
  }

  // ============================================================
  // refreshDrawer
  // /cart.js does not return rendered sections, so we fetch them
  // with the Section Rendering API and pass them to patchContents.
  // ============================================================
  async refreshDrawer() {
    const [sections, cart] = await Promise.all([
      fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`).then(r => r.json()),
      fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json())
    ]);
    this.patchContents({ ...cart, sections });
  }

  async reapplyPlanToRemainingItems(planId) {
    try {
      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
      if (!cart.items || cart.items.length === 0) return;
      
      const sellingPlanId = parseInt(planId);
      
      const eligibilityPromises = cart.items.map(async (item, index) => {
        try {
          const productData = await fetch(`/products/${item.handle}.js`).then(r => r.json());
          const supportsPlan = (productData.selling_plan_groups || []).some(group =>
            group.selling_plans.some(plan => plan.id === sellingPlanId)
          );
          return { index, supportsPlan };
        } catch (e) {
          return { index, supportsPlan: false };
        }
      });
      
      const eligibilityResults = await Promise.all(eligibilityPromises);
      
      for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        const planToApply = eligibilityResults[i].supportsPlan ? sellingPlanId : null;
        
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            line: i + 1,
            quantity: item.quantity,
            selling_plan: planToApply
          })
        });
      }
      
    } catch (error) {
      console.error('Error reapplying plan after removal:', error);
    }
  }

  overrideQuantityUpdates() {
    const quantityWrappers = this.querySelectorAll('.quantity');
    
    quantityWrappers.forEach(wrapper => {
      const input = wrapper.querySelector('.quantity__input');
      const minusBtn = wrapper.querySelector('button[name="minus"]');
      const plusBtn = wrapper.querySelector('button[name="plus"]');
      
      if (!input) return;
      
      const lineIndex = input.dataset.index;
      if (!lineIndex) return;
      
      if (minusBtn) {
        const newMinus = minusBtn.cloneNode(true);
        minusBtn.parentNode.replaceChild(newMinus, minusBtn);
        newMinus.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const currentValue = parseInt(input.value) || 0;
          if (currentValue > 0) {
            this.updateQuantity(lineIndex, currentValue - 1);
          }
        });
      }
      
      if (plusBtn) {
        const newPlus = plusBtn.cloneNode(true);
        plusBtn.parentNode.replaceChild(newPlus, plusBtn);
        newPlus.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const currentValue = parseInt(input.value) || 0;
          this.updateQuantity(lineIndex, currentValue + 1);
        });
      }
      
      const newInput = input.cloneNode(true);
      input.parentNode.replaceChild(newInput, input);
      newInput.addEventListener('change', (e) => {
        const newValue = parseInt(e.target.value) || 0;
        if (newValue >= 0) {
          this.updateQuantity(lineIndex, newValue);
        }
      });
    });
  }

  async updateQuantity(lineIndex, quantity) {
    const itemEl = document.getElementById('CartDrawer-Item-' + lineIndex);
    const itemOverlay = itemEl ? itemEl.querySelector('.loading-overlay') : null;
    const subtotalOverlay = document.querySelector('.totals__subtotal-value .loading-overlay');

    if (itemOverlay) itemOverlay.classList.remove('hidden');
    if (subtotalOverlay) subtotalOverlay.classList.remove('hidden');
    
    try {
      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
      const item = cart.items[parseInt(lineIndex) - 1];
      if (!item) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.open();
        return;
      }
      
      const subscribeRadio = document.getElementById('purchase-subscribe');
      const freqSelect = document.getElementById('frequency-select');
      const selectedPlan = (subscribeRadio && subscribeRadio.checked) ? freqSelect?.value : null;
      
      let planToApply = selectedPlan ? parseInt(selectedPlan) : null;
      
      if (planToApply) {
        try {
          const productData = await fetch(`/products/${item.handle}.js`).then(r => r.json());
          const supportsPlan = (productData.selling_plan_groups || []).some(group =>
            group.selling_plans.some(plan => plan.id === planToApply)
          );
          if (!supportsPlan) {
            planToApply = null;
          }
        } catch (e) {
          planToApply = null;
        }
      }
      
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          line: parseInt(lineIndex),
          quantity: quantity,
          selling_plan: planToApply,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      
      if (!response.ok) {
        throw new Error(`Failed to update quantity: ${response.status}`);
      }
      
      const cartData = await response.json();
      
      // Patch only what changed instead of re-rendering the whole drawer
      this.patchContents(cartData, lineIndex);
      
      setTimeout(() => {
        if (typeof window.updateWidgetState === 'function') {
          window.updateWidgetState();
        }
        if (typeof window.updateMinimumOrderWarning === 'function') {
          window.updateMinimumOrderWarning();
        }
      }, 100);
      
    } catch (error) {
      console.error('Error updating quantity:', error);
      const statusDiv = document.getElementById('widget-status');
      if (statusDiv) {
        statusDiv.textContent = 'Failed to update quantity. Please try again.';
        statusDiv.style.color = '#b73c24';
      }
    } finally {
      if (itemOverlay) itemOverlay.classList.add('hidden');
      if (subtotalOverlay) subtotalOverlay.classList.add('hidden');
    }
  }

  // ============================================================
  // NEW: patchContents
  // Updates only the line items that changed, plus the header
  // count, totals/footer and cart icon bubble. Keeps scroll
  // position intact. Falls back to a full renderContents when
  // the cart is empty or the expected markup is missing.
  // ============================================================
  patchContents(cartData, lineIndex) {
    const html = cartData && cartData.sections && cartData.sections['cart-drawer'];
    // Fall back to the full re-render if the cart is empty or data is missing
    if (!html || cartData.item_count === 0) return this.renderContents(cartData);

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newDrawer = doc.querySelector('#CartDrawer');
    const oldWrap = this.querySelector('.drawer__cart-items-wrapper');
    const newWrap = newDrawer && newDrawer.querySelector('.drawer__cart-items-wrapper');
    if (!newWrap || !oldWrap) return this.renderContents(cartData);

    // Compare items ignoring the loading overlay
    const sig = (el) => {
      const c = el.cloneNode(true);
      c.querySelector('.loading-overlay')?.remove();
      return c.innerHTML;
    };

    // 1. Only replace line items that actually changed
    const newItems = [...newWrap.children];
    const oldItems = [...oldWrap.children];
    newItems.forEach((n, i) => {
      const o = oldItems[i];
      if (!o) oldWrap.appendChild(n);
      else if (o.id !== n.id || sig(o) !== sig(n)) o.replaceWith(n);
    });
    oldItems.slice(newItems.length).forEach((o) => o.remove()); // removed lines

    // 2. Swap the small shared pieces (header count, totals/footer)
    // Add your free-shipping progress bar selector here if it should update live
    ['.drawer__header-title', '.cart-drawer__footer'].forEach((sel) => {
      const oldEl = this.querySelector(sel);
      const newEl = newDrawer.querySelector(sel);
      if (oldEl && newEl) oldEl.replaceWith(newEl);
    });

    // 2b. Free-shipping progress bar
    this.updateShippingBar(newDrawer);

    // 3. Cart icon bubble in the header
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && cartData.sections['cart-icon-bubble']) {
      bubble.innerHTML = this.getSectionInnerHTML(cartData.sections['cart-icon-bubble']);
    }

    // 4. Re-wire buttons on the new nodes
    this.overrideQuantityUpdates();
    this.overrideRemoveButtons();

    // Keep keyboard focus on the same control
    if (lineIndex) {
      this.querySelector(`#CartDrawer-Item-${lineIndex} button[name="plus"]`)?.focus();
    }
  }

  // ============================================================
  // NEW: updateShippingBar
  // Updates the free-shipping bar in place (so the width animates)
  // using the fresh data-total from the re-rendered section.
  // ============================================================
  updateShippingBar(newDrawer) {
    const oldEl = this.querySelector('.cart-shipping');
    const newEl = newDrawer && newDrawer.querySelector('.cart-shipping');
    if (!oldEl || !newEl) return;

    // Sync the fresh values, then let the theme's own cartShipping()
    // (cart.js, CartItems) update the bar and messages.
    oldEl.dataset.total = newEl.dataset.total;
    oldEl.dataset.cartIsEmpty = newEl.dataset.cartIsEmpty;
    const themeItems = this.querySelector('cart-drawer-items');
    if (themeItems && typeof themeItems.cartShipping === 'function') {
      themeItems.cartShipping();
      return;
    }
    // Fallback below only runs if the theme method isn't available

    const total = Number(newEl.dataset.total) || 0;
    // Min spend is entered in the store currency; apply the customer's currency rate
    const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    const min = (Number(newEl.dataset.minSpend) || 0) * rate;
    oldEl.dataset.total = newEl.dataset.total;
    oldEl.dataset.cartIsEmpty = newEl.dataset.cartIsEmpty;
    if (!min) return;

    const defaultMsg = oldEl.querySelector('.cart-shipping__message_default');
    const successMsg = oldEl.querySelector('.cart-shipping__message_success');
    const reached = total >= min;
    const percent = Math.min(100, Math.max(0, (total / min) * 100));

    // Progress width (the CSS reads --progress-prev)
    oldEl.style.setProperty('--progress-prev', percent + '%');
    oldEl.style.setProperty('--progress', percent + '%');

    // Money formatting
    const fmt = (cents) => {
      // global.js helper, uses the theme's money format
      if (typeof window.formatMoney === 'function' && window.theme && theme.moneyFormat) {
        return formatMoney(cents, theme.moneyFormat);
      }
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    };

    if (reached) {
      defaultMsg?.classList.remove('active');
      successMsg?.classList.add('active');
    } else {
      successMsg?.classList.remove('active');
      if (defaultMsg) {
        const template = (oldEl.dataset.message || '').trim();
        const remaining = fmt(min - total);
        const token = /\|\|\s*amount\s*\|\||\{\{\s*amount\s*\}\}|\{\s*amount\s*\}|\[\s*amount\s*\]/gi;
        defaultMsg.textContent = token.test(template)
          ? template.replace(token, remaining)
          : (template + ' ' + remaining).trim();
        defaultMsg.classList.add('active');
      }
    }
  }

  renderContents(parsedState) {
    try {
      if (!parsedState || !parsedState.sections) {
        this.open();
        return;
      }

      if (parsedState.item_count === 0) {
        this.querySelector(".drawer__inner")?.classList.add("is-empty");
      } else {
        this.querySelector(".drawer__inner")?.classList.remove("is-empty");
      }

      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        
        if (sectionElement && parsedState.sections && parsedState.sections[section.id]) {
          sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
      });

      setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay")?.addEventListener(
          "click",
          this.close.bind(this, false)
        );
        this.open();
        if (
          document.querySelector("cart-popular-products-slider") &&
          typeof document.querySelector("cart-popular-products-slider").init ===
            "function"
        ) {
          document.querySelector("cart-popular-products-slider").init();
        }
        
        this.initSubscriptionWidget();
        this.overrideQuantityUpdates();
        this.overrideRemoveButtons();
        
        setTimeout(() => {
          if (typeof window.updateMinimumOrderWarning === 'function') {
            window.updateMinimumOrderWarning();
          }
        }, 200);
      }, 100);
    } catch (error) {
      console.error('Error in renderContents:', error);
      this.open();
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  initSubscriptionWidget() {
    const widget = document.getElementById('subscription-widget');
    if (!widget) return;

    if (this.classList.contains('is-empty')) {
      widget.style.display = 'none';
      return;
    } else {
      widget.style.display = 'block';
    }

    const statusDiv = document.getElementById('widget-status');
    if (statusDiv) {
      statusDiv.textContent = '';
    }
    
    const onetimeRadio = document.getElementById('purchase-onetime');
    if (onetimeRadio && onetimeRadio.dataset.wired !== 'true') {
      if (typeof setupWidget === 'function') {
        setupWidget();
      }
    }
    
    if (typeof window.updateWidgetState === 'function') {
      setTimeout(() => {
        window.updateWidgetState();
      }, 100);
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);